import React from 'react';
import classNames from 'classnames';

import css from './Icons.module.css';

const IconFilter = props => {
  const { className } = props;
  const classes = classNames(className, css.root);

  return (
    <svg
      className={classes}
      width="18"
      height="12"
      viewBox="0 0 18 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M7 12H11V10H7V12ZM0 0V2H18V0H0ZM3 7H15V5H3V7Z" fill="#C4DB44" />
    </svg>
  );
};

export default IconFilter;
